module.exports = __webpack_public_path__ + "static/media/question.b6edacd4.svg";